import { render, staticRenderFns } from "./UserPaperPreview.vue?vue&type=template&id=18bc55c7&scoped=true"
import script from "./UserPaperPreview.vue?vue&type=script&lang=js"
export * from "./UserPaperPreview.vue?vue&type=script&lang=js"
import style0 from "./UserPaperPreview.vue?vue&type=style&index=0&id=18bc55c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bc55c7",
  null
  
)

export default component.exports